import { Component, Input } from '@angular/core';
import { ViewModelProperty } from '../../models';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ldw-vmp-label',
  templateUrl: './vmp-label.component.html',
  styleUrls: ['./vmp-label.component.css'],
  imports: [TranslatePipe]
})
export class VMPLabelComponent {
  @Input() vmp: ViewModelProperty | undefined = undefined;

  get caption(): string {
    if (this.vmp == undefined || this.vmp.caption == undefined) {
      return '';
    }
    return this.vmp.caption;
  }
}
